export * from './filters.module';
export * from './shared';


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/index.ts